var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { DATA_CACHE_SIZE } from '@lucidlink/sdk';
import { translate } from '@lucidlink/uicore';
import { DEFAULT_LOCAL_CACHE_SIZE } from '#constants';
import { DEPENDENCY_KEYS, useDependency } from '#context';
import { convertToMiB, convertUnitToInt, sizeToValueAndUnit } from '#services';
export const useLocalCacheSize = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { handleToasts } = useDependency(DEPENDENCY_KEYS.UseFilespaceSettingsToasts)({
        filespaceId,
        workspaceId,
        settingName: DATA_CACHE_SIZE,
    });
    const { mutation: { isSuccess, mutate: setGlobalSettings }, } = useDependency(DEPENDENCY_KEYS.UseSetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: DATA_CACHE_SIZE,
    }, {
        onSuccess: () => {
            handleToasts();
        },
    });
    const onSave = useCallback((localCacheSize, unit) => setGlobalSettings([
        {
            fullName: DATA_CACHE_SIZE,
            value: String(convertToMiB(localCacheSize, unit)),
        },
    ]), [setGlobalSettings]);
    const { mutation: { mutate: unsetGlobalSetting }, } = useDependency(DEPENDENCY_KEYS.UseUnsetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: DATA_CACHE_SIZE,
    }, {
        onSuccess: () => {
            handleToasts({ isReset: true });
        },
    });
    const onReset = useCallback(() => unsetGlobalSetting([DATA_CACHE_SIZE]), [unsetGlobalSetting]);
    const { default: defaultValue, isDefault, value } = data;
    const labelDefault = isDefault ? translate('Default') : undefined;
    const labelTooltip = [
        translate("The maximum local cache size on each user's device. The default limit is {{DEFAULT_LOCAL_CACHE_SIZE}}. Up to 80% of the allocated space is available for pinning.", { DEFAULT_LOCAL_CACHE_SIZE }),
    ];
    const { unit: initialUnitValue, value: initialNumberValue } = convertUnitToInt(sizeToValueAndUnit(Number(value)));
    const { unit: defaultUnitValue, value: defaultNumberValue } = sizeToValueAndUnit(Number(defaultValue));
    const resetToDefault = isDefault
        ? undefined
        : {
            label: translate('Reset to default'),
            onReset,
            tooltip: translate('The default value is: {{defaultNumberValue}} {{defaultUnitValue}}', { defaultUnitValue, defaultNumberValue }),
        };
    return {
        isSuccess,
        resetToDefault,
        onSave,
        initialNumberValue,
        initialUnitValue,
        labelDefault,
        labelTooltip,
    };
};
_react_refresh_temp_1(useLocalCacheSize, "VZHiePq7Mq9k9weZbwoXeO0xygQ=", false, () => [useDependency, useDependency, useDependency]);
